/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
    TransactionTypeToJSONTyped,
} from './TransactionType';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';
import type { TransactionStatus } from './TransactionStatus';
import {
    TransactionStatusFromJSON,
    TransactionStatusFromJSONTyped,
    TransactionStatusToJSON,
    TransactionStatusToJSONTyped,
} from './TransactionStatus';

/**
 * An inbound payment transaction for a claim.
 * @export
 * @interface ClaimTransaction
 */
export interface ClaimTransaction {
    /**
     * 
     * @type {number}
     * @memberof ClaimTransaction
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimTransaction
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimTransaction
     */
    companyId: number;
    /**
     * 
     * @type {TransactionType}
     * @memberof ClaimTransaction
     */
    transactionType: TransactionType;
    /**
     * Amount in cents (always positive)
     * @type {number}
     * @memberof ClaimTransaction
     */
    amountCents: number;
    /**
     * Fee amount in cents taken from this payment
     * @type {number}
     * @memberof ClaimTransaction
     */
    feeCents?: number | null;
    /**
     * Date of the transaction (YYYY-MM-DD)
     * @type {string}
     * @memberof ClaimTransaction
     */
    transactionDate: string;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof ClaimTransaction
     */
    paymentMethod?: PaymentMethod;
    /**
     * 
     * @type {string}
     * @memberof ClaimTransaction
     */
    referenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimTransaction
     */
    payee?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimTransaction
     */
    payer?: string | null;
    /**
     * 
     * @type {TransactionStatus}
     * @memberof ClaimTransaction
     */
    status: TransactionStatus;
    /**
     * 
     * @type {string}
     * @memberof ClaimTransaction
     */
    notes?: string | null;
    /**
     * Blob ID for an attached check image/PDF (null if none)
     * @type {number}
     * @memberof ClaimTransaction
     */
    readonly checkFileBlobId?: number | null;
    /**
     * Original filename of the attached check file
     * @type {string}
     * @memberof ClaimTransaction
     */
    readonly checkFileName?: string | null;
    /**
     * MIME type of the attached check file (e.g., image/jpeg, application/pdf)
     * @type {string}
     * @memberof ClaimTransaction
     */
    readonly checkFileMimeType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimTransaction
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimTransaction
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimTransaction
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the ClaimTransaction interface.
 */
export function instanceOfClaimTransaction(value: object): value is ClaimTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('amountCents' in value) || value['amountCents'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimTransactionFromJSON(json: any): ClaimTransaction {
    return ClaimTransactionFromJSONTyped(json, false);
}

export function ClaimTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'companyId': json['companyId'],
        'transactionType': TransactionTypeFromJSON(json['transactionType']),
        'amountCents': json['amountCents'],
        'feeCents': json['feeCents'] == null ? undefined : json['feeCents'],
        'transactionDate': json['transactionDate'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : PaymentMethodFromJSON(json['paymentMethod']),
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'payee': json['payee'] == null ? undefined : json['payee'],
        'payer': json['payer'] == null ? undefined : json['payer'],
        'status': TransactionStatusFromJSON(json['status']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'checkFileBlobId': json['checkFileBlobId'] == null ? undefined : json['checkFileBlobId'],
        'checkFileName': json['checkFileName'] == null ? undefined : json['checkFileName'],
        'checkFileMimeType': json['checkFileMimeType'] == null ? undefined : json['checkFileMimeType'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ClaimTransactionToJSON(json: any): ClaimTransaction {
    return ClaimTransactionToJSONTyped(json, false);
}

export function ClaimTransactionToJSONTyped(value?: Omit<ClaimTransaction, 'id'|'checkFileBlobId'|'checkFileName'|'checkFileMimeType'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'companyId': value['companyId'],
        'transactionType': TransactionTypeToJSON(value['transactionType']),
        'amountCents': value['amountCents'],
        'feeCents': value['feeCents'],
        'transactionDate': value['transactionDate'],
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'referenceNumber': value['referenceNumber'],
        'payee': value['payee'],
        'payer': value['payer'],
        'status': TransactionStatusToJSON(value['status']),
        'notes': value['notes'],
        'createdBy': value['createdBy'],
    };
}

